import { markRaw } from 'vue';
import type { HasMetadata, Integration } from './types/integration';

export const defineIntegration = <Code extends string, Config, PreSetupPayload, Metadata>(
  code: Code,
  integration: {
    config: () => Config;
    metadata?: HasMetadata<Metadata>;
    preSetup?: (payload: PreSetupPayload) => void;
    setup?: Integration<Code, Config, PreSetupPayload, Metadata>['setup'];
    update?: Integration<Code, Config>['update'];
    teardown?: Integration<Code, Config>['teardown'];
    components?: Integration<Code, Config>['components'];
  },
): Integration<Code, Config, PreSetupPayload, Metadata> => {
  return {
    code,
    dependencies: [],
    config: integration.config,
    metadata: integration.metadata,
    preSetup: integration.preSetup || (() => {}),
    setup: integration.setup || (() => {}),
    teardown: integration.teardown || (() => {}),
    update: integration.update || (() => {}),
    components: markRaw(integration.components || {}),
    resolved: true,
  };
};
